import React, { useEffect, useRef, useState } from "react";

const ScaledHTML = ({ htmlContent }) => {
	const containerRef = useRef(null);
	const contentRef = useRef(null);
	const [scale, setScale] = useState(1);
	const [contentWidth, setContentWidth] = useState(1);
	const [contentHeight, setContentHeight] = useState(1);

	useEffect(() => {
		const updateScale = () => {
			if (containerRef.current && contentRef.current) {
				const parentWidth = containerRef.current.parentElement?.clientWidth || 1;

				// Create a temporary element to render HTML content and measure its width and height
				const tempDiv = document.createElement("div");
				tempDiv.style.visibility = "hidden";
				tempDiv.style.position = "absolute";
				tempDiv.innerHTML = htmlContent;
				document.body.appendChild(tempDiv);

				const calculatedContentWidth = tempDiv.offsetWidth;
				const calculatedContentHeight = tempDiv.offsetHeight;
				setContentWidth(calculatedContentWidth);
				setContentHeight(calculatedContentHeight);

				// Only calculate scale if content width exceeds parent width
				if (calculatedContentWidth > parentWidth) {
					// Calculate scale based on content and parent container width
					const newScale = parentWidth / calculatedContentWidth;
					setScale(newScale);
				} else {
					// If content width is less than parent width, don't apply scaling
					setScale(1);
				}

				document.body.removeChild(tempDiv);
			}
		};

		updateScale();
		window.addEventListener("resize", updateScale);
		return () => window.removeEventListener("resize", updateScale);
	}, [htmlContent]);

	useEffect(() => {
		if (containerRef.current && contentHeight) {
			const scaledHeight = contentHeight * scale;
			containerRef.current.style.height = `${scaledHeight}px`; // Adjust the parent height based on scale
		}
	}, [scale, contentHeight]);

	return (
		<div ref={containerRef} style={{ width: "100%", overflow: "hidden" }}>
			<div
				ref={contentRef}
				style={{
					transform: `scale(${scale})`,
					transformOrigin: "top left",
					width: `${100 / scale}%`, // Maintain width proportion
					height: `${100 / scale}%`, // Maintain height proportion
				}}
				dangerouslySetInnerHTML={{ __html: htmlContent }}
			/>
		</div>
	);
};

export default ScaledHTML;
